import React, { useState, useEffect } from 'react';
import {
    getOrderStatusSettings,
    // loginUsers,
    setPrimaryColour,
    // parseURLBuildingId,
    setLocalOrderStatusSettings,
    getLocalUserInfoLocalStorage,
    // parseURLUserId,
    parseURLuid,
    getFireBaseConfigs
} from "../utils/utils";
// import { setLocalToken } from "../utils/localstorage";
import { translate } from "../utils/translation";
import { initialiseFirebase } from "../firebase/Firebase";

export default function Login({ setToken, setOrderStatusSetting }) {
    // const [username, setUserName] = useState();
    // const [password, setPassword] = useState();

    useEffect(() => {
        // Your code here
        handleSubmit();
    }, []);
    const { defaultLanguage } = getLocalUserInfoLocalStorage();
    const language = defaultLanguage || 'en';
    const handleSubmit = async () => {
        // e.preventDefault();
        // const token = await loginUsers({
        //     username,
        //     password
        // });
        // if (!token.hasOwnProperty("access_token")) {
        //     alert('Incorrect Login Credentials');
        // } else {
            const uid = parseURLuid();
            let orderStatusSettings;
            if (uid) {
                orderStatusSettings = await getOrderStatusSettings(uid);
                if (
                    orderStatusSettings && orderStatusSettings.status !== "error" &&
                    orderStatusSettings.length > 0 && orderStatusSettings[0].json
                ) {
                    setLocalOrderStatusSettings(JSON.parse(orderStatusSettings[0].json))
                }

                const fireBaseConfigs = await getFireBaseConfigs(uid);
                if (fireBaseConfigs && fireBaseConfigs.appId) {
                    initialiseFirebase(fireBaseConfigs);
                }
            }


            // try {
            //     setLocalToken(token["access_token"]);
            // } catch (err) {}
            setToken('abc'); /// just set dummy token to maintain prev flow
            if (orderStatusSettings && orderStatusSettings.status !== "error") {
                setOrderStatusSetting(orderStatusSettings)
            }

            const params = getLocalUserInfoLocalStorage();
            const primaryColour = params['primaryColour'];
            setPrimaryColour(primaryColour);
        // }
    };

    return (
        <div className="login-wrapper">
            <h1>{translate('LOADING', language)}&hellip;</h1>
            {/* <form onSubmit={handleSubmit}>
                <label className="label-field">
                    <input className="form-control" placeholder="Username" type="text"
                           onChange={e => setUserName(e.target.value)} />
                </label>
                <label className="label-field">
                    <input className="form-control" placeholder="Password" type="password"
                           onChange={e => setPassword(e.target.value)} />
                </label>
                <div>
                    <button className="btn btn-light m-3" type="submit">Submit</button>
                </div>
            </form> */}
        </div>
    )
}
